module.exports = __webpack_public_path__ + "static/media/salutebellezza.5b8bbef7.png";